export function isUnderTest() {
	return import.meta?.env?.TEST === 'true';
}
